import { Cancel } from '@mui/icons-material';
import { Grid } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import '../../../styles/fileupload.css';
import CustomButton from '../../elements/CustomButton';
import Modal from '../../elements/Modal';

function EditPicture({
  handleClose,
  open,
  onSubmit,
  width,
  productPictures: initialProductPictures,
  loading,
}) {
  const dragItem = useRef();
  const dragOverItem = useRef();
  const [productPictures, setProductPictures] = useState(
    initialProductPictures || []
  );

  const dragStart = (e, position) => {
    dragItem.current = position;
    // console.log(e.target.innerHTML);
  };

  const dragEnter = (e, position) => {
    dragOverItem.current = position;
    // console.log(e.target.innerHTML);
  };

  const drop = (e) => {
    const copyListItems = [...productPictures];
    const dragItemContent = copyListItems[dragItem.current];
    copyListItems.splice(dragItem.current, 1);
    copyListItems.splice(dragOverItem.current, 0, dragItemContent);
    dragItem.current = null;
    dragOverItem.current = null;
    setProductPictures(copyListItems);
  };
  const handleRemoveImage = (index) => {
    const updatedPictures = [...productPictures];
    updatedPictures.splice(index, 1);
    setProductPictures(updatedPictures);
  };

  useEffect(() => {
    setProductPictures(initialProductPictures);
  }, [initialProductPictures]);

  return (
    <Modal
      open={open}
      modalTitle="Edit product pictures"
      handleClose={handleClose}
      width={width || 'sm'}>
      <Grid
        style={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          justifyContent: 'flex-start',
          alignItems: 'flex-start',
        }}>
        {productPictures &&
          productPictures?.map((image, index) => (
            <div
              key={index}
              style={{
                marginBottom: '12px',
                display: 'flex',
                justifyContent: 'center',
                margin: '15px',
                alignItems: 'flex-start',
                position: 'relative',
              }}
              onDragStart={(e) => dragStart(e, index)}
              onDragEnter={(e) => dragEnter(e, index)}
              onDragEnd={drop}
              draggable>
              <img
                src={`${image}?w=80&h=80&fit=crop&auto=format`}
                srcSet={`${image}?w=80&h=80&fit=crop&auto=format&dpr=2 2x`}
                style={{
                  width: '70px',
                  height: '70px',
                  objectFit: 'cover',
                  background: 'none',
                  padding: 0,
                  border: '2px solid grey',
                  borderRadius: '4px',
                }}
                alt={image}
              />
              <Cancel
                style={{
                  position: 'absolute',
                  top: '2px',
                  right: '2px',
                  transform: 'translate(50%, -50%)',
                  cursor: 'pointer',
                  color: 'red',
                }}
                onClick={() => handleRemoveImage(index)}
              />
            </div>
          ))}
      </Grid>
      <Grid container justifyContent="center">
        <Grid
          item
          sx={{ width: '300px', display: 'flex', justifyContent: 'center' }}>
          <CustomButton
            disabled={loading}
            buttonLabel={loading ? 'Saving...' : 'Save'}
            onClick={() => onSubmit(productPictures)}
          />
        </Grid>
      </Grid>
    </Modal>
  );
}

export default EditPicture;
